// 图表类可视化看板配色
// 设计稿 https://codesign.qq.com/app/design/2kY5j3AQEX0ExNd/board
export const chartsColors = [
  "#03BF8A",
  "#448FFF",
  "#FFCB42",
  "#FF9542",
  "#43D1E0",
  "#FF5660",
  "#FF80C8",
  "#8679ED",
  "#8DD36F",
  "#3AE7A1",
  "#FAE13C",
  "#5D7093",
];
